"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formilyFormGrid = exports.formilyTimePicker = exports.formilyCascader = exports.formilyStepper = exports.formilySwitch = exports.formilyFormItem = void 0;
var reactive_vue_1 = require("@formily/reactive-vue");
var vue_1 = require("@formily/vue");
var vue_demi_1 = require("vue-demi");
var dayjs_1 = __importDefault(require("dayjs"));
var input_1 = require("@formily/vant/esm/input");
var Cascader_1 = __importDefault(require("./Cascader"));
var Calendar_1 = __importDefault(require("./Calendar"));
var Space_1 = __importDefault(require("./Space"));
var TimePicker_1 = __importDefault(require("./TimePicker"));
var vant_1 = require("@formily/vant");
var element_1 = require("@formily/element");
var vant_2 = require("vant");
// @ts-ignore
var store_1 = __importDefault(require("../../store"));
var BaseFormItem = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'FBaseFormItem',
    props: {
        label: {},
        gridSpan: {},
    },
    setup: function (props, _a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var attrs = _a.attrs, slots = _a.slots, listeners = _a.listeners, emit = _a.emit;
        var field = (0, vue_1.useField)();
        // 判断是否为 Radio/Checkbox 组件（在 return 外部计算，避免重复计算）
        var isRadioOrCheckbox = ((_c = (_b = field.value) === null || _b === void 0 ? void 0 : _b.component) === null || _c === void 0 ? void 0 : _c[0]) === 'Radio' ||
            ((_e = (_d = field.value) === null || _d === void 0 ? void 0 : _d.component) === null || _e === void 0 ? void 0 : _e[0]) === 'Radio.Group' ||
            ((_g = (_f = field.value) === null || _f === void 0 ? void 0 : _f.component) === null || _g === void 0 ? void 0 : _g[0]) === 'Checkbox' ||
            ((_j = (_h = field.value) === null || _h === void 0 ? void 0 : _h.component) === null || _j === void 0 ? void 0 : _j[0]) === 'Checkbox.Group';
        // 读取 inputDescFix 配置，判断是否启用 description 修复逻辑
        var inputDescFixEnabled = false;
        try {
            var configStr = store_1.default.getters.getConfigItem('inputDescFix');
            //          const configStr = `{
            //   "open":false,
            //   "key":["Vxiangloli-Test-AiDesigner","wb_sub_ticket","Infrastructure_Maintenance_Main_Process_Rental","Infrastructure_Maintenance_Main_Process_self-establish","maintenace_problem_solve_ticket_3.0","maintenance_overseer_record"]
            // }`;
            if (configStr) {
                try {
                    var config = JSON.parse(configStr);
                    var isOpen = config.open === true;
                    if (!isOpen) {
                        inputDescFixEnabled = false;
                    }
                    else {
                        var keyArray = Array.isArray(config.key) ? config.key : [];
                        if (keyArray.length === 0) {
                            inputDescFixEnabled = true;
                        }
                        else {
                            var currentProcessKey = ((_k = store_1.default.state.config) === null || _k === void 0 ? void 0 : _k.ProcessDefinitionKey) || '';
                            inputDescFixEnabled = !!(currentProcessKey && keyArray.includes(currentProcessKey));
                        }
                    }
                }
                catch (parseError) {
                    console.warn('[FormItem] inputDescFix 配置解析失败，降级为布尔值判断', parseError);
                    inputDescFixEnabled = false;
                }
            }
        }
        catch (e) {
            // store 不可用时降级为关闭
        }
        return function () {
            var _a;
            return (0, vue_1.h)(vant_2.Field, {
                class: (_a = {},
                    _a['formily-vant-input-asterisk'] = attrs.asterisk || field.value.decoratorProps.asterisk,
                    // 仅在 inputDescFix 启用且为 Radio/Checkbox 时才添加布局类名
                    _a['formily-vant-field-radio'] = inputDescFixEnabled && isRadioOrCheckbox,
                    _a),
                attrs: __assign(__assign(__assign({}, attrs), props), { 'data-grid-span': props.gridSpan, clearable: field.value.componentProps.clearable, disabled: field.value.pattern === 'disabled', 'clear-trigger': 'always', 
                    // placeholder: field.value.componentProps.placeholder,
                    placeholder: attrs.placeholder || field.value.componentProps.placeholder || '请填写' + (field.value.title || '') }),
                on: __assign(__assign({}, listeners), { change: function (val) {
                        emit('change', val);
                        field.value.setValue(val);
                    }, clear: function (e) {
                        e.stopPropagation();
                        field.value.setValue(null);
                    } }),
            }, __assign({ input: function () { var _a, _b; return (_b = (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)) !== null && _b !== void 0 ? _b : []; } }, getFormItemSlots(attrs, field, slots, isRadioOrCheckbox, inputDescFixEnabled)));
        };
    },
}));
exports.formilyFormItem = (0, vue_1.connect)(BaseFormItem, input_1.inputValidate);
exports.formilySwitch = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'formilySwitch',
    props: ['value'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        var field = (0, vue_1.useField)();
        return function () {
            return (0, vue_1.h)(vant_1.Switch, {
                attrs: __assign(__assign(__assign({}, curProps), attrs), { disabled: field.value.pattern === 'disabled', readonly: field.value.pattern === 'readonly', inactiveColor: '#dcdee0' }),
                style: __assign(__assign({}, attrs.style), { margin: '0 auto' }),
                on: {
                    change: function (val) {
                        if (val === field.value.value)
                            return;
                        emit('change', val);
                    },
                },
            }, {
                default: function () { return [curProps.value]; },
            });
        };
    },
}));
exports.formilyStepper = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'formilyStepper',
    props: ['value', 'options'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        var field = (0, vue_1.useField)();
        return function () {
            return (0, vue_1.h)(vant_1.Stepper, {
                attrs: __assign(__assign(__assign({ min: -99999 }, curProps), attrs), { 'allow-empty': true, defaultValue: null, 'decimal-length': attrs.precision }),
                style: __assign(__assign({}, attrs.style), { margin: '0 auto' }),
                on: {
                    change: function (val) {
                        emit('change', val);
                        field.value.setValue(val);
                    },
                },
            }, {
                default: function () { return [curProps.value]; },
            });
        };
    },
}));
exports.formilyCascader = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'formilyCascader',
    props: ['value', 'options'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        var field = (0, vue_1.useField)();
        return function () {
            return (0, vue_1.h)(Cascader_1.default, {
                attrs: __assign(__assign(__assign({}, curProps), attrs), { formItemProps: {
                        fieldNames: {
                            text: 'name',
                            value: 'code',
                            children: 'items',
                        },
                    } }),
                on: {
                    change: function (val) {
                        emit('change', val);
                        field.value.setValue(val);
                    },
                },
            }, __assign({ default: function () { return [curProps.value]; } }, getFormItemSlots(attrs, field, null, false, false)));
        };
    },
}));
var DATE_TYPE = {
    month: 'year-month',
    date: 'single',
    dates: 'multiple',
    daterange: 'range',
    datetime: 'datetime',
};
var DATE_VALUE_TYPE = {
    month: 'YYYY-MM',
    date: 'YYYY-MM-DD',
    dates: 'YYYY-MM-DD',
    daterange: 'YYYY-MM-DD',
    datetime: 'YYYY-MM-DD HH:mm',
};
var isCalendar = function (type) {
    var _a;
    if (type === void 0) { type = 'date'; }
    return (_a = ['date', 'dates', 'daterange'].includes(type)) !== null && _a !== void 0 ? _a : true;
};
exports.formilyTimePicker = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'formilyTimePicker',
    props: ['value'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        var field = (0, vue_1.useField)();
        var IS_CALENDAR = isCalendar(attrs.type);
        return function () {
            var _a, _b, _c;
            return (0, vue_1.h)(IS_CALENDAR ? Calendar_1.default : TimePicker_1.default, {
                attrs: __assign(__assign(__assign({}, curProps), attrs), { calendarProps: __assign(__assign({}, attrs), { type: DATE_TYPE[(_a = attrs.type) !== null && _a !== void 0 ? _a : 'date'], 'min-date': (_b = new Date(new Date().getFullYear() - 10, 1, 0)) !== null && _b !== void 0 ? _b : attrs['min-date'], 'max-date': (_c = new Date(new Date().getFullYear() + 10, 1, 0)) !== null && _c !== void 0 ? _c : attrs['max-date'] }), datetimePickerProps: __assign(__assign({}, attrs), { type: DATE_TYPE[attrs.type] }) }),
                on: {
                    change: function (val) {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        emit('change', Array.isArray(val)
                            ? val.map(function (item) { return formatDate(item, attrs.format || attrs.type); })
                            : formatDate(val, ((_d = (_c = (_b = (_a = attrs.format) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, 'yyyy', 'YYYY')) === null || _c === void 0 ? void 0 : _c.replace) === null || _d === void 0 ? void 0 : _d.call(_c, 'dd', 'DD')) || attrs.type));
                        field.value.setValue(Array.isArray(val)
                            ? val.map(function (item) { return formatDate(item, attrs.format || attrs.type); })
                            : formatDate(val, ((_h = (_g = (_f = (_e = attrs.format) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, 'yyyy', 'YYYY')) === null || _g === void 0 ? void 0 : _g.replace) === null || _h === void 0 ? void 0 : _h.call(_g, 'dd', 'DD')) || attrs.type));
                    },
                },
            }, {
                default: function () {
                    var _a, _b, _c, _d;
                    return [
                        attrs.type === 'dates'
                            ? (_b = (_a = curProps.value) === null || _a === void 0 ? void 0 : _a.join) === null || _b === void 0 ? void 0 : _b.call(_a, ', ')
                            : (_d = (_c = curProps.value) === null || _c === void 0 ? void 0 : _c.join) === null || _d === void 0 ? void 0 : _d.call(_c, ' 至 '),
                    ];
                },
            });
        };
    },
}));
exports.formilyFormGrid = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'formilyFormGrid',
    props: {
        label: {},
        value: {},
    },
    setup: function (props, _a) {
        var attrs = _a.attrs, slots = _a.slots;
        var field = (0, vue_1.useField)();
        var data = field.value.componentProps;
        console.log('data', data);
        console.log('attrsassss', attrs);
        return function () {
            var content = (0, vue_1.h)(attrs.mobile ? element_1.FormGrid : Space_1.default, {
                attrs: __assign(__assign({}, attrs), props),
                style: __assign({}, (attrs.style || {}))
            }, {
                default: function () { var _a, _b; return (_b = (_a = slots === null || slots === void 0 ? void 0 : slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)) !== null && _b !== void 0 ? _b : []; },
            });
            // 如果floating为true，使用Sticky组件包裹
            if (data === null || data === void 0 ? void 0 : data.floating) {
                return (0, vue_1.h)(vant_2.Sticky, {
                    attrs: {
                        offsetTop: 10,
                        zIndex: 7,
                        ref: 'sticky',
                    },
                }, {
                    default: function () { return content; },
                });
            }
            return content;
        };
    },
}));
var formatDate = function (val, type) {
    var _a;
    if (type === void 0) { type = 'date'; }
    return (0, dayjs_1.default)(val).format((_a = DATE_VALUE_TYPE[type]) !== null && _a !== void 0 ? _a : type);
};
var getFormItemSlots = function (attrs, field, slots, isRadioOrCheckbox, inputDescFixEnabled) {
    // 检查字段是否在 ArrayTable 或 MobileArrayCards 父容器中
    // 通过 field.parent 向上遍历判断是否在数组容器中
    var checkIsInTargetParent = function () {
        var _a;
        try {
            var parent_1 = (_a = field.value) === null || _a === void 0 ? void 0 : _a.parent;
            while (parent_1) {
                var comp = parent_1.component;
                var compName = Array.isArray(comp) ? comp[0] : (typeof comp === 'string' ? comp : '');
                if (compName === 'ArrayTable' || compName === 'NewArrayTable') {
                    return true;
                }
                parent_1 = parent_1.parent;
            }
        }
        catch (error) {
            console.warn('[FormItem] 检查父容器失败', error);
        }
        return false;
    };
    var isInTargetParent = checkIsInTargetParent();
    return {
        extra: function () {
            var extraContent = [];
            if (field.value.decoratorProps.addonAfter) {
                extraContent.push(field.value.decoratorProps.addonAfter);
            }
            // 对于 Radio/Checkbox 组件，把 description 渲染到 extra（下方），避免挤占内容区域
            // 仅在 inputDescFix 启用、且在指定的父容器中时才生效
            if (inputDescFixEnabled && isRadioOrCheckbox && field.value.description && isInTargetParent) {
                var desc_1 = field.value.description;
                extraContent.push((0, vue_1.h)('div', {
                    class: 'formily-vant-field-desc-radio',
                    attrs: {
                    // style: 'flex-basis:100%;width:100%;max-width:100%;margin-top:4px;font-size:12px;color:#969799;line-height:1.5;text-align:left;',
                    },
                }, {
                    default: function () {
                        if (typeof desc_1 === 'string') {
                            return desc_1;
                        }
                        else if (desc_1 && typeof desc_1 === 'object' && desc_1.tag) {
                            return [desc_1];
                        }
                        else if (desc_1 && typeof desc_1 === 'object') {
                            return String(desc_1);
                        }
                        return desc_1;
                    }
                }));
            }
            return extraContent;
        },
        button: attrs.clearable && attrs.value
            ? function () { return [
                (0, vue_1.h)(vant_2.Icon, {
                    attrs: {
                        name: 'clear',
                    },
                    class: ['van-field__clear'],
                    on: {
                        click: function (e) {
                            e.stopPropagation();
                            field.value.form.setValuesIn(field.value.path, null);
                        },
                    },
                }, {}),
            ]; }
            : undefined,
        // 非 Radio/Checkbox 的组件：始终在 label 位置显示 description
        // Radio/Checkbox 组件：
        //   - inputDescFix 未启用 → 始终在 label 位置显示 description
        //   - inputDescFix 启用 + 不在数组容器中 → 在 label 位置显示 description
        //   - inputDescFix 启用 + 在数组容器中 → 不在 label 显示（已在 extra 中渲染）
        label: (!isRadioOrCheckbox && field.value.description)
            ? function () { return [
                (0, vue_1.h)(vant_2.Cell, {
                    attrs: {
                        label: field.value.description,
                        title: field.value.title,
                        disabled: field.value.pattern === 'disabled',
                    },
                }, {}),
            ]; }
            : (isRadioOrCheckbox && field.value.description && !(inputDescFixEnabled && isInTargetParent))
                ? function () { return [
                    (0, vue_1.h)(vant_2.Cell, {
                        attrs: {
                            label: field.value.description,
                            title: field.value.title,
                            disabled: field.value.pattern === 'disabled',
                        },
                    }, {}),
                ]; }
                : undefined,
        'left-icon': field.value.decoratorProps.tooltip
            ? function () { return [
                (0, vue_1.h)(vant_2.Icon, {
                    attrs: {
                        name: 'info',
                    },
                    // 让图标看起来"可点击"
                    style: { cursor: 'pointer' },
                    on: {
                        // 点击 i 图标弹出提示文案（来自 decoratorProps.tooltip，兼容 description）
                        click: function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            var message = field.value.decoratorProps.tooltip ||
                                field.value.description ||
                                '';
                            if (!message)
                                return;
                            try {
                                vant_2.Dialog.alert({
                                    title: field.value.title || '提示',
                                    message: String(message),
                                    confirmButtonText: '我知道了',
                                    messageAlign: 'left',
                                }).catch(function () {
                                    // 用户关闭弹窗时 Dialog.alert 会 reject，忽略即可
                                });
                            }
                            catch (err) {
                                // eslint-disable-next-line no-console
                                console.warn('[FormItem] tooltip dialog failed:', err);
                            }
                        },
                    },
                }, {}),
            ]; }
            : undefined,
        'right-icon': slots && slots['right-icon'],
    };
};
